import React from "react";
import "../About.css";

import { useContract, useClaimedNFTSupply } from "@thirdweb-dev/react";

function JoyrideCount() {
	const contractAddress = "0x8Ad8E3345F349f6Ea985E61C1a4336c56357D41a";
	const { contract } = useContract(contractAddress);
	const { data: claimedNFTSupply } = useClaimedNFTSupply(contract);
	return (
		<>
			<span className="claimed">{claimedNFTSupply?.toNumber()}/25 Claimed</span>
		</>
	);
}

export default JoyrideCount;
